import React, {Fragment, useContext, useEffect, useRef, useState} from 'react';
import {Nav, NavDropdown} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import {useDebouncedCallback} from 'use-debounce';
import {useLazyQuery} from '@apollo/client';
import {useLocation} from 'react-router-dom';
import {AuthContext} from '../../context/auth-context';
import useBootstrapBreakpoint from '../../hooks/useBootstrapBreakpoint';
import useHover from '../../hooks/useHover';
import Link from '../../components/analytics/Link';
import {HUBS} from '../../queries/hub';
import headerDropdownStyles from './css/HeaderDropdown.module.scss';
import styles from './css/HealthcareDropdown.module.scss';
const {hubTypes, specialHubs} = require('../../commons/v3/server/types/hubTypes');


export default function ManagementDropdown() {
	const [showDropdown, setShowDropdown] = useState(false);
	const [containerIsHovered, setContainerIsHovered] = useState(false);
	const [panelLeft, setPanelLeft] = useState(0);
	const {isAuthenticated} = useContext(AuthContext);
	const location = useLocation();
	const [hoverRef, isHovered] = useHover();
	const buttonRef = useRef(null);
	const [fetchHubs, {data}] = useLazyQuery(HUBS);

	const {callback: debouncedSetShowDropdown} = useDebouncedCallback((show) => setShowDropdown(show), 25);

	const bootstrapBreakpoint = useBootstrapBreakpoint();

	useEffect(() => {
		if (isAuthenticated) {
			fetchHubs();
		}
	}, [isAuthenticated, fetchHubs]);

	useEffect(() => {
		if (containerIsHovered || isHovered) {
			if (buttonRef.current) {
				const rect = buttonRef.current.getBoundingClientRect();
				setPanelLeft(rect.left + rect.width / 2);
			}
			debouncedSetShowDropdown(true);
		} else {
			debouncedSetShowDropdown(false);
		}
		// eslint-disable-next-line
	}, [containerIsHovered, isHovered]);

	useEffect(() => {
		setShowDropdown(false);
	}, [location]);

	if (!isAuthenticated) return null;

	const hubs = data ? data.hubs : [];
	const hubMap = Object.fromEntries(hubs.map((h) => [h.ID, h]));
	const managementHubs = Object.values(specialHubs)
		.filter((sh) => sh.TypeID === hubTypes.MANAGEMENT)
		.map((sh) => hubMap[sh.ID])
		.filter(Boolean);
	const allItems = managementHubs.map((hub) => ({label: hub.Title, to: `/hub/${hub.ID}/${hub.Slug}`}));

	if (bootstrapBreakpoint === 'sm' || bootstrapBreakpoint === 'xs') {
		return (
			<NavDropdown className="xsMarketDropdownContainer" title="MANAGEMENT BEST PRACTICES">
				{allItems.map((item) =>
					item.to ? (
						<LinkContainer key={item.label} to={item.to}>
							<NavDropdown.Item active={false}>{item.label}</NavDropdown.Item>
						</LinkContainer>
					) : (
						<NavDropdown.Item key={item.label} disabled>
							{item.label}
						</NavDropdown.Item>
					)
				)}
			</NavDropdown>
		);
	}

	return (
		<Fragment>
			<Nav.Link
				className={`${styles.healthcareButton} ${headerDropdownStyles.dropdownButton} ${showDropdown ? 'active' : ''}`}
				onClick={() => setShowDropdown(!showDropdown)}
				ref={(el) => { hoverRef(el); buttonRef.current = el; }}
			>
				MANAGEMENT BEST PRACTICES
			</Nav.Link>
			{showDropdown && (
				<div
					className={styles.dropdownPanel}
					style={{left: panelLeft, transform: 'translateX(-50%)'}}
					onMouseEnter={() => setContainerIsHovered(true)}
					onMouseLeave={() => setContainerIsHovered(false)}
				>
					<div className={styles.columnsGrid}>
						<div className={`${styles.column} ${styles.lastColumn}`}>
							{allItems.map((item) =>
								item.to ? (
									<div key={item.label}>
										<Link
											onClick={() => setShowDropdown(false)}
											className={styles.sectionTitle}
											to={item.to}
											description="navbar"
											resourceType="Hub"
										>
											{item.label}
										</Link>
									</div>
								) : (
									<div key={item.label}>
										<span className={styles.sectionTitle} style={{opacity: 0.6, cursor: 'default'}}>
											{item.label}
										</span>
									</div>
								)
							)}
						</div>
					</div>
				</div>
			)}
		</Fragment>
	);
}
